// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import Snotify, { SnotifyPosition } from 'vue-snotify'
import JQuery from 'jquery'
import VueSlideBar from 'vue-slide-bar'
import VueSweetalert2 from 'vue-sweetalert2'
import VueGoodWizard from 'vue-good-wizard'
// eslint-disable-next-line
import VueMask from 'v-mask'
// eslint-disable-next-line
import { VueMaskDirective } from 'v-mask'

import VueQuillEditor from 'vue-quill-editor'
// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import 'cropperjs/dist/cropper.css'

// eslint-disable-next-line
let $ = JQuery

const options = {
  confirmButtonColor: '#41b882',
  cancelButtonColor: '#ff7674'
}

Vue.use(BootstrapVue)
Vue.use(Snotify, {
  toast: {
    position: SnotifyPosition.rightTop,
    timeout: 5000,
    showProgressBar: true,
    closeOnClick: true,
    pauseOnHover: false
  }
})
Vue.use(VueSweetalert2, options)
Vue.use(VueGoodWizard)
Vue.use(VueMask)
Vue.directive('mask', VueMaskDirective)
Vue.use(require('vue-moment'))
Vue.component('vue-slide-bar', VueSlideBar)
Vue.config.productionTip = false

Vue.use(VueQuillEditor, options)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js